const api = {
  /**
   * 用户在官网填写咨询信息, 发送对应邮件给销售
   * @method POST
   */
  contactUs: '/users/consulting-us',
};

export default api;
